// extracted by mini-css-extract-plugin
module.exports = {"game-notifier-alert":"style_game-notifier-alert__1Lbi6","close":"style_close__3X-8Z","small-view-top-right":"style_small-view-top-right__2rvzH"};